import Text from "../../../../styleguide/Text";
import CustomButton from "../../../../components/CustomButton";
import SvgIcon from "../../../../helpers/SvgIcon";

function TableCustomHeader() {
  return (
    <div className="d-flex align-items-center justify-content-between mb-3">
      <Text
        variant="h3"
        component="h3"
        className="card-title mb-4"
        gutterBottom>
        Flota cu nodurile corespunzatoare
      </Text>

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Adauga masina noua"
        navigate="create">
        <SvgIcon type="ADD" />
      </CustomButton>
    </div>
  );
}

export default TableCustomHeader;
